import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = {
  key: 0,
  class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
  href: "#",
  "data-bs-toggle": "modal",
  "data-bs-target": "#AddPermissionModal"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 2,
  class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
  type: "button",
  disabled: ""
}
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_11 = { class: "table-responsive" }
const _hoisted_12 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_18 = { class: "dropdown" }
const _hoisted_19 = { class: "dropdown-menu" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_AddPermissionModal = _resolveComponent("AddPermissionModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.checkPermission('AddPermission'))
            ? (_openBlock(), _createElementBlock("a", _hoisted_4, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1),
                _createTextVNode(" Ajouter une permission ", -1)
              ]))]))
            : _createCommentVNode("", true),
          (_ctx.valideEtape3)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.telecharger && _ctx.telecharger(...args))),
                disabled: _ctx.isLoading,
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
                type: "button"
              }, [
                _cache[6] || (_cache[6] = _createElementVNode("i", { class: "flaticon-download position-relative ms-5 fs-12" }, null, -1)),
                (!_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Exporter"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, [...(_cache[5] || (_cache[5] = [
                      _createElementVNode("span", {
                        class: "spinner-grow spinner-grow-sm me-2",
                        role: "status",
                        "aria-hidden": "true"
                      }, null, -1),
                      _createTextVNode(" Export en cours... ", -1)
                    ]))]))
              ], 8, _hoisted_5))
            : _createCommentVNode("", true),
          (!_ctx.valideEtape3)
            ? (_openBlock(), _createElementBlock("button", _hoisted_8, [...(_cache[7] || (_cache[7] = [
                _createElementVNode("span", {
                  class: "spinner-grow spinner-grow-sm",
                  role: "status",
                  "aria-hidden": "true"
                }, null, -1),
                _createElementVNode("span", { class: "visually-hidden" }, "Chargement...", -1)
              ]))]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("form", {
            class: "search-box position-relative me-15",
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchTerm) = $event)),
              onKeyup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
              class: "form-control shadow-none text-black rounded-0 border-0",
              placeholder: "Rechercher un privelege"
            }, null, 544), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("button", {
              type: "submit",
              class: "bg-transparent text-primary transition p-0 border-0"
            }, [
              _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
            ], -1))
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("table", _hoisted_12, [
            _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, "Nom "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, "Description "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, "Rôle "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, "DATE DE CREATION "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                }, " Actions")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.permissions, (permission, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_13, _toDisplayString(permission.nom), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(permission.description), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permission.rolePermissions, (rolePermission, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: index,
                          class: "badge text-bg-primary rounded-pill fs-13 me-5"
                        }, [
                          (rolePermission.role)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(rolePermission.role.description), 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.format_date(permission.createdAt)), 1),
                  _createElementVNode("td", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _cache[11] || (_cache[11] = _createElementVNode("span", {
                        class: "badge text-white bg-primary fs-15 dropdown-toggle",
                        "data-bs-toggle": "dropdown",
                        "aria-expanded": "false"
                      }, [
                        _createTextVNode(" Actions "),
                        _createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
                      ], -1)),
                      _createElementVNode("ul", _hoisted_19, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);",
                            onClick: ($event: any) => (_ctx.moddifier(permission))
                          }, [...(_cache[9] || (_cache[9] = [
                            _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode(" Modifier ", -1)
                          ]))], 8, _hoisted_20)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);",
                            onClick: ($event: any) => (_ctx.suppression(permission.id, _ctx.permissions, 'permissions', `le permission ${permission.description}`))
                          }, [...(_cache[10] || (_cache[10] = [
                            _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode(" Supprimer ", -1)
                          ]))], 8, _hoisted_21)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createVNode(_component_AddPermissionModal, {
      onGetAllPermissions: _ctx.getAllPermissions,
      id: _ctx.idpermission,
      onOpenmodal: _ctx.showModalEdite
    }, null, 8, ["onGetAllPermissions", "id", "onOpenmodal"])
  ], 64))
}